// the code below works locally and it should also work in production.  If it does not work in production, revert to this:
// export const BASE_API = "https://frp.purepm.co/api";

export const BASE_API = import.meta.env.MODE === "development" ? "http://localhost:1337/api" : "/api";
